import React, { useCallback, useState } from 'react';

import { CardControlPanel as CardControlPanelV3 } from '@eika-kortbetjening/card-control-panel';

import { CreditCardService } from '@/domain/card';
import { useIsHighFraudRisk } from '@/hooks/use-is-high-risk';
import piwik from '@/piwik/piwik';

import { CreditCard } from '@generated-types';

import { Modals, ModalState } from './Modals';

type CreditCardControlPanelProps = {
    card: CreditCard;
    showButtons?: boolean;
};

export const CreditCardControlPanel = ({ card, showButtons = true }: CreditCardControlPanelProps) => {
    const isHighRisk = useIsHighFraudRisk();

    const isAllowedToViewCardsPin = card.allowedOperations.getPin;
    const isAllowedToViewVirtualCards = card.allowedOperations.getVirtualCard;

    const [modalState, setModalState] = useState<ModalState>({
        showDigitalCardModal: false,
        showPinModal: false,
        showCardActivationModal: false,
    });

    const onClickPin = useCallback(() => {
        if (!card) {
            return;
        }

        setModalState({ ...modalState, showPinModal: true });
    }, [card, modalState]);

    const openDigitalCardModal = useCallback(() => {
        setModalState({ ...modalState, showDigitalCardModal: true });
    }, [modalState]);

    const [kbjCard, kbjCardMeta] = CreditCardService.toKbjPanel(card, () => '');

    return (
        <>
            <CardControlPanelV3
                cardMeta={kbjCardMeta}
                card={kbjCard}
                onDigitalCardClick={
                    (isAllowedToViewVirtualCards && !isHighRisk && showButtons && openDigitalCardModal) || undefined
                }
                onSeePinClick={(isAllowedToViewCardsPin && showButtons && onClickPin) || undefined}
                piwik={piwik}
            />
            <Modals card={card} modalState={modalState} setModalState={setModalState} />
        </>
    );
};
